export default {
  /**
   * handleError is a function that handles errors and displays a toast notification with the error message.
   *
   * @param {Object} error - The error object that needs to be handled.
   * @param {Function} updateToast - A function that updates the toast notification with the provided message and type.
   */
  handleError: (error, updateToast) => {
    console.error(error);
    updateToast({
      message: 'Une erreur est survenue: ' + error.message,
      type: 'error',
    });
    setTimeout(async () => {
      const bootstrap = await import('bootstrap/dist/js/bootstrap.bundle.min');
      const toast = document.getElementById('default-toast');
      const toastInstance = bootstrap.Toast.getOrCreateInstance(toast);
      toastInstance.show();
    }, 100);
  },
};
